import React, { Component } from 'react';
import {
  Well
} from 'react-bootstrap';
import { formatTotal } from '../helpers';

class Profile extends Component {
  render() {
    const { totalLifted } = this.props;

    return(
      <Well>
        <h4>{this.props.displayName}</h4>
        <h1>{formatTotal(totalLifted)}</h1>
      </Well>
    );
  }
}

Profile.propTypes = {
  displayName: React.PropTypes.string.isRequired,
  totalLifted: React.PropTypes.number.isRequired
}

export default Profile;


// WEBPACK FOOTER //
// ./src/components/Profile.jsx